'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var debounce = require("debounce");
var sanitize = require("sanitize-filename");
var arr_1 = require("../../shared/utils/arr");
var messenger_1 = require("../../shared/utils/messenger");
var obj_1 = require("../../shared/utils/obj");
var str_1 = require("../../shared/utils/str");
var typeCheck_1 = require("../../shared/utils/typeCheck");
var fileInputGroup = $('.file-input-group');
var inputTypeFile = $('.input-type-file');
var importFileFeedback = $('.input-type-file-feedback');
var customFileControl = $('.custom-file-control');
var themeNameGroup = $('.theme-name-group');
var themeNameFeedback = $('.theme-name-feedback');
var themeNoteTextArea = $('.theme-note-textarea');
var exportButton = $('.export-button');
var jetIframe = document.querySelector('.jet-iframe');
var otherWindow = jetIframe.contentWindow;
var ThemeEditorFile;
(function (ThemeEditorFile) {
    ThemeEditorFile.COLOR_PICKER_OPTIONS = {
        align: 'left',
        customClass: 'colorpicker-2x',
        format: 'rgba',
        sliders: {
            saturation: {
                maxLeft: 200,
                maxTop: 200
            },
            hue: {
                maxTop: 200
            }
        }
    };
    ThemeEditorFile.GROUPS = {
        AIRCRAFT: 'Aircraft',
        COCKPIT: 'Cockpit',
        FUSELAGE: 'Fuselage',
        ICON: 'Icon',
        SEAT: 'Seat',
        SEAT_BAR: 'Seat Bar',
        SEAT_MAP: 'Seat Map',
        TOOTLTIP: 'Tooltip'
    };
    ThemeEditorFile.themeColors = [
        {
            attribute: 'aircraft__background_color',
            groupName: ThemeEditorFile.GROUPS.AIRCRAFT,
            id: 'aircraftBackgroundColor',
            label: 'Aircraft Background Color',
            order: 0,
            color: 'rgb(58, 192, 236)'
        }, {
            attribute: 'bulk_base__fill',
            groupName: ThemeEditorFile.GROUPS.AIRCRAFT,
            id: 'bulkBaseFill',
            label: 'Bulk Base Fill',
            order: 0,
            color: 'rgb(185, 186, 186)'
        }, {
            attribute: 'bulk_cut__fill',
            groupName: ThemeEditorFile.GROUPS.AIRCRAFT,
            id: 'bulkCutFill',
            label: 'Bulk Cut Fill',
            order: 0,
            color: 'rgb(237, 237, 237)'
        }, {
            attribute: 'floor__fill',
            groupName: ThemeEditorFile.GROUPS.AIRCRAFT,
            id: 'floorFill',
            label: 'Floor Fill',
            order: 0,
            color: 'rgb(82, 82, 86)'
        }, {
            attribute: 'turbine_tail_wing__stroke',
            groupName: ThemeEditorFile.GROUPS.AIRCRAFT,
            id: 'turbineTailWingStroke',
            label: 'Turbine Tail Wing Stroke',
            order: 0,
            color: 'rgb(255, 255, 255)'
        }, {
            attribute: 'cockpit_door__fill',
            groupName: ThemeEditorFile.GROUPS.COCKPIT,
            id: 'cockpitDoorFill',
            label: 'Cockpit Door Fill',
            order: 0,
            color: 'none'
        }, {
            attribute: 'cockpit_door__stroke',
            groupName: ThemeEditorFile.GROUPS.COCKPIT,
            id: 'cockpitDoorStroke',
            label: 'Cockpit Door Stroke',
            order: 0,
            color: 'rgb(82, 82, 86)'
        }, {
            attribute: 'cockpit_windows__fill',
            groupName: ThemeEditorFile.GROUPS.COCKPIT,
            id: 'cockpitWindowsFill',
            label: 'Cockpit Windows Fill',
            order: 0,
            color: 'rgb(255, 255, 255)'
        }, {
            attribute: 'fuselage__fill',
            groupName: ThemeEditorFile.GROUPS.FUSELAGE,
            id: 'fuselageFill',
            label: 'Fuselage Fill',
            order: 0,
            color: 'rgb(237, 237, 237)'
        }, {
            attribute: 'fuselage_cut__fill',
            groupName: ThemeEditorFile.GROUPS.FUSELAGE,
            id: 'fuselageCutFill',
            label: 'Fuselage Cut Fill',
            order: 0,
            color: 'rgb(255, 255, 255)'
        }, {
            attribute: 'fuselage_separator__fill',
            groupName: ThemeEditorFile.GROUPS.FUSELAGE,
            id: 'fuselageSeparatorFill',
            label: 'Fuselage Separator Fill',
            order: 0,
            color: 'none'
        }, {
            attribute: 'fuselage_separator__stroke',
            groupName: ThemeEditorFile.GROUPS.FUSELAGE,
            id: 'fuselageSeparatorStroke',
            label: 'Fuselage Separator Stroke',
            order: 0,
            color: 'rgb(255, 255, 255)'
        }, {
            attribute: 'icon__bulk__fill',
            groupName: ThemeEditorFile.GROUPS.ICON,
            id: 'iconBulkFill',
            label: 'Icon Bulk Fill',
            order: 0,
            color: 'rgba(0, 0, 0, 0.4)'
        }, {
            attribute: 'seat_armrest__fill',
            groupName: ThemeEditorFile.GROUPS.SEAT,
            id: 'seatArmrestFill',
            label: 'Seat Armrest Fill',
            order: 0,
            color: 'rgb(185, 186, 186)'
        }, {
            attribute: 'seat_base__fill',
            groupName: ThemeEditorFile.GROUPS.SEAT,
            id: 'seatBaseFill',
            label: 'Seat Base Fill',
            order: 0,
            color: 'rgb(237, 237, 237)'
        }, {
            attribute: 'seat_headrest__fill',
            groupName: ThemeEditorFile.GROUPS.SEAT,
            id: 'seatHeadrestFill',
            label: 'Seat Headrest Fill',
            order: 0,
            color: 'rgb(253, 255, 255)'
        }, {
            attribute: 'seatbar__background_color',
            groupName: ThemeEditorFile.GROUPS.SEAT_BAR,
            id: 'seatbarBackgroundColor',
            label: 'Seatbar Background Color',
            order: 0,
            color: 'rgba(0, 0, 0, 0.75)'
        }, {
            attribute: 'seatbar_guests__color',
            groupName: ThemeEditorFile.GROUPS.SEAT_BAR,
            id: 'seatbarGuestsColor',
            label: 'Seatbar Guests Color',
            order: 0,
            color: 'rgb(255, 255, 255)'
        }, {
            attribute: 'seatbar_seats__color',
            groupName: ThemeEditorFile.GROUPS.SEAT_BAR,
            id: 'seatbarSeatsColor',
            label: 'Seatbar Seats Color',
            order: 0,
            color: 'rgb(255, 255, 255)'
        }, {
            attribute: 'seatbar_separator__color',
            groupName: ThemeEditorFile.GROUPS.SEAT_BAR,
            id: 'seatbarSeparatorColor',
            label: 'Seatbar Separator Color',
            order: 0,
            color: 'rgb(255, 255, 255)'
        }, {
            attribute: 'seatbar_arrow__fill_color',
            groupName: ThemeEditorFile.GROUPS.SEAT_BAR,
            id: 'seatbarArrowFillColor',
            label: 'Seatbar Arrow Fill Color',
            order: 0,
            color: 'rgb(255, 255, 255)'
        }, {
            attribute: 'seatbar_armchair__fill_color',
            groupName: ThemeEditorFile.GROUPS.SEAT_BAR,
            id: 'seatbarArmchairFillColor',
            label: 'Seatbar Armchair Fill Color',
            order: 0,
            color: 'rgb(255, 255, 255)'
        }, {
            attribute: 'seatmap_base__color',
            groupName: ThemeEditorFile.GROUPS.SEAT_MAP,
            id: 'seatmapBaseColor',
            label: 'Seatmap Base Color',
            order: 0,
            color: 'rgb(185, 186, 186)'
        }, {
            attribute: 'seatmap_base__fill',
            groupName: ThemeEditorFile.GROUPS.SEAT_MAP,
            id: 'seatmapBaseFill',
            label: 'Seatmap Base Fill',
            order: 0,
            color: 'rgb(237, 237, 237)'
        }, {
            attribute: 'seatmap_seatnumber__fill',
            groupName: ThemeEditorFile.GROUPS.SEAT_MAP,
            id: 'seatmapSeatnumberFill',
            label: 'Seatmap Seatnumber Fill',
            order: 0,
            color: 'rgb(82, 82, 86)'
        }, {
            attribute: 'tooltip_arrow__border_color',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipArrowBorderColor',
            label: 'Tooltip Arrow Border Color',
            order: 0,
            color: 'rgba(255, 255, 255, 0.95)'
        }, {
            attribute: 'tooltip_button__border_color',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipButtonBorderColor',
            label: 'Tooltip Button Border Color',
            order: 0,
            color: 'rgb(20, 183, 237)'
        }, {
            attribute: 'tooltip_button__color',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipButtonColor',
            label: 'Tooltip Button Color',
            order: 0,
            color: 'rgb(20, 183, 237)'
        }, {
            attribute: 'tooltip_button_icon__fill',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipButtonIconFill',
            label: 'Tooltip Button Icon Fill',
            order: 0,
            color: 'rgb(20, 183, 237)'
        }, {
            attribute: 'tooltip_feature_label__color',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipFeatureLabelColor',
            label: 'Tooltip Feature Label Color',
            order: 0,
            color: 'rgb(82, 82, 86)'
        }, {
            attribute: 'tooltip_feature_svg__fill',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipFeatureSvgFill',
            label: 'Tooltip Feature Svg Fill',
            order: 0,
            color: 'rgb(82, 82, 86)'
        }, {
            attribute: 'tooltip_feature_svg__stroke',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipFeatureSvgStroke',
            label: 'Tooltip Feature Svg Stroke',
            order: 0,
            color: 'rgb(82, 82, 86)'
        }, {
            attribute: 'tooltip_header__color',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipHeaderColor',
            label: 'Tooltip Header Color',
            order: 0,
            color: 'rgb(82, 82, 86)'
        }, {
            attribute: 'tooltip_hint__color',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipHintColor',
            label: 'Tooltip Hint Color',
            order: 0,
            color: 'rgb(82, 82, 86)'
        }, {
            attribute: 'tooltip_unit__border_color',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipUnitBorderColor',
            label: 'Tooltip Unit Border Color',
            order: 0,
            color: 'rgba(0, 0, 0, 0.3)'
        }, {
            attribute: 'tooltip_unit__color',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipUnitColor',
            label: 'Tooltip Unit Color',
            order: 0,
            color: 'rgb(82, 82, 86)'
        }, {
            attribute: 'tooltip_unit_svg__fill',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipUnitSvgFill',
            label: 'Tooltip Unit Svg Fill',
            order: 0,
            color: 'rgb(189, 191, 190)'
        }, {
            attribute: 'tooltip_vr__color',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipVrColor',
            label: 'Tooltip Vr Color',
            order: 0,
            color: 'rgb(20, 183, 237)'
        }, {
            attribute: 'tooltip_vr_icon__fill',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipVrIconFill',
            label: 'Tooltip Vr Icon Fill',
            order: 0,
            color: 'rgb(20, 183, 237)'
        }, {
            attribute: 'tooltip_wrapper__background_color',
            groupName: ThemeEditorFile.GROUPS.TOOTLTIP,
            id: 'tooltipWrapperBackgroundColor',
            label: 'Tooltip Wrapper Background Color',
            order: 0,
            color: 'rgba(255, 255, 255, 0.95)'
        }
    ];
    function getDomColorPickerComponents() {
        return $('.colorpicker-component');
    }
    ThemeEditorFile.getDomColorPickerComponents = getDomColorPickerComponents;
    function getDomColorPickerInputs() {
        return $('.colorpicker-input');
    }
    ThemeEditorFile.getDomColorPickerInputs = getDomColorPickerInputs;
    function getDomThemeNameInput() {
        return $('.theme-name-input');
    }
    ThemeEditorFile.getDomThemeNameInput = getDomThemeNameInput;
    function handleFileSelect(jQueryEventObject) {
        var files = jQueryEventObject.target.files;
        if (files && files[0] && files[0].size) {
            var reader = new FileReader();
            reader.addEventListener('loadend', function (e) {
                var fileContent = e.target.result;
                if (typeCheck_1.TypeCheck.json(fileContent)) {
                    var data = JSON.parse(fileContent);
                    spreadImportedData(data);
                    styleFileInputAsSuccess(files[0].name);
                }
                else {
                    styleFileInputAsDanger();
                }
                resetInputFile();
            });
            reader.readAsText(files[0]);
        }
    }
    ThemeEditorFile.handleFileSelect = handleFileSelect;
    function resetFileInputStyle() {
        fileInputGroup.removeClass('has-success has-danger');
        importFileFeedback.addClass('text-muted').text('Import colour theme from your computer');
        customFileControl.attr('data-after', 'Choose file...');
    }
    ThemeEditorFile.resetFileInputStyle = resetFileInputStyle;
    function styleFileInputAsSuccess(fileName) {
        resetFileInputStyle();
        fileInputGroup.addClass('has-success');
        importFileFeedback.removeClass('text-muted').text('File successfully imported');
        customFileControl.attr('data-after', fileName);
    }
    ThemeEditorFile.styleFileInputAsSuccess = styleFileInputAsSuccess;
    function styleFileInputAsDanger() {
        resetFileInputStyle();
        fileInputGroup.addClass('has-danger');
        importFileFeedback.removeClass('text-muted').text('File is not valid JSON');
    }
    ThemeEditorFile.styleFileInputAsDanger = styleFileInputAsDanger;
    function resetInputFile() {
        var inputClone = inputTypeFile.val('').clone(true);
        inputTypeFile.off('change', handleFileSelect);
        inputTypeFile.replaceWith(inputClone);
        inputTypeFile = inputClone;
    }
    ThemeEditorFile.resetInputFile = resetInputFile;
    function spreadImportedData(data) {
        var nameKey = 'name';
        var noteKey = 'note';
        for (var key in data) {
            $("[data-type='" + key + "']").parent('.colorpicker-component').colorpicker('setValue', data[key]);
        }
        if (data.hasOwnProperty('name')) {
            getDomThemeNameInput().val(data[nameKey]);
            handleThemeNameChange();
        }
        if (data.hasOwnProperty('note')) {
            themeNoteTextArea.text(data[noteKey]);
        }
    }
    ThemeEditorFile.spreadImportedData = spreadImportedData;
    function handleColorChange() {
        var data = collectColorData();
        resetFileInputStyle();
        messenger_1.Messenger.send(otherWindow, 'colorChange', data);
    }
    ThemeEditorFile.handleColorChange = handleColorChange;
    function collectColorData() {
        var data = {};
        getDomColorPickerInputs()
            .each(function (index, htmlInputElement) {
            var color = htmlInputElement.value;
            var type = htmlInputElement.getAttribute('data-type');
            if (type) {
                data[type] = color;
            }
        });
        for (var name_1 in data) {
            var color = data[name_1];
            if (color.startsWith('rgba(') && ((color.split(',').length - 1) >= 3)) {
                if (color.endsWith(',1)')) {
                    data[name_1] = color.replace('rgba(', 'rgb(').replace(',1)', ')');
                }
                else if (color.endsWith(',0)')) {
                    data[name_1] = 'transparent';
                }
            }
        }
        return data;
    }
    ThemeEditorFile.collectColorData = collectColorData;
    function handleThemeNameChange() {
        var isFileNameValid = getValidatedFileName();
        resetFileInputStyle();
        if (isFileNameValid) {
            resetThemeNameInputStyle();
        }
    }
    ThemeEditorFile.handleThemeNameChange = handleThemeNameChange;
    function getValidatedFileName() {
        var fileName = str_1.Str.trim(getDomThemeNameInput().val());
        var sanitizeFileName = sanitize(fileName);
        var isFileNameValid = fileName && fileName === sanitizeFileName;
        if (isFileNameValid) {
            return sanitizeFileName;
        }
        styleThemeNameInputAsDanger();
        return '';
    }
    ThemeEditorFile.getValidatedFileName = getValidatedFileName;
    function resetThemeNameInputStyle() {
        themeNameGroup.removeClass('has-danger');
        themeNameFeedback.text('\u00A0');
    }
    ThemeEditorFile.resetThemeNameInputStyle = resetThemeNameInputStyle;
    function styleThemeNameInputAsDanger() {
        themeNameGroup.addClass('has-danger');
        themeNameFeedback.text('File name is not valid.');
    }
    ThemeEditorFile.styleThemeNameInputAsDanger = styleThemeNameInputAsDanger;
    function handleExportClick(event) {
        event.preventDefault();
        var name = getValidatedFileName();
        if (name) {
            var note = themeNoteTextArea.val();
            var data = { name: name, note: note };
            data = Object.assign(data, collectColorData());
            var fileContent = JSON.stringify(data, Object.keys(data).sort());
            window.download(fileContent, name + ".json", 'text/plain');
        }
    }
    ThemeEditorFile.handleExportClick = handleExportClick;
    function lumaCoefficient(color) {
        var rgb = Number.parseInt(color.substring(1), 16);
        return 0.2126 * ((rgb >> 16) & 0xff) + 0.7152 * ((rgb >> 8) & 0xff) + 0.0722 * ((rgb >> 0) & 0xff);
    }
    ThemeEditorFile.lumaCoefficient = lumaCoefficient;
    function isDark(color, alpha, consideredDarkOn) {
        if (alpha === void 0) { alpha = 1; }
        if (consideredDarkOn === void 0) { consideredDarkOn = 64; }
        return (lumaCoefficient(color) / alpha) < consideredDarkOn;
    }
    ThemeEditorFile.isDark = isDark;
    function init() {
        var inputs = {};
        ThemeEditorFile.themeColors
            .forEach(function (themeColor) {
            var attribute = themeColor.attribute, color = themeColor.color, groupName = themeColor.groupName, id = themeColor.id, label = themeColor.label, order = themeColor.order;
            var input = templateInputColorPicker(id, label, attribute, color);
            if (groupName in inputs === false) {
                inputs[groupName] = [];
            }
            inputs[groupName] = arr_1.Arr.insertAt(inputs[groupName], order, input);
        });
        var template = '';
        obj_1.Obj
            .forEach(inputs, function (inputList, groupLabel) {
            template += templateFormGroup(groupLabel, inputList.join('\n'));
        });
        $('#colors')
            .append($(template))
            .collapse();
        getDomColorPickerComponents()
            .colorpicker(ThemeEditorFile.COLOR_PICKER_OPTIONS)
            .on({
            changeColor: debounce(function onColorPickerEvent(eventObject) {
                var rgb = eventObject.color.toRGB();
                $("." + ThemeEditorFile.COLOR_PICKER_OPTIONS.customClass + " .colorpicker-color *")
                    .html("&nbsp;rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")")
                    .css('color', isDark(eventObject.color.toHex(), rgb.a) ? 'white' : 'black');
            }, 300)
        });
        inputTypeFile.change(handleFileSelect);
        getDomColorPickerInputs().change(handleColorChange);
        getDomThemeNameInput().on('keyup change', debounce(handleThemeNameChange, 300));
        themeNoteTextArea.on('keyup change', debounce(resetFileInputStyle, 300));
        exportButton.click(handleExportClick);
        var iframe = $('#iframe').get(0);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('marginheight', '0');
        iframe.setAttribute('marginwidth', '0');
        iframe.setAttribute('scrolling', 'yes');
        iframe.addEventListener('load', function handleSeatMapLoad(event) {
            var targetIframe = event.currentTarget;
            var targetIframeWindow = targetIframe.contentWindow;
            var message = {
                data: { flightGuid: '1ABC', passengers: [{ id: '1', seat: null, seatPreference: null }] },
                type: 'SYNC_PASSENGERS'
            };
            targetIframeWindow.postMessage(JSON.stringify(message), '*');
            setTimeout(function () {
                var message = { data: { label: '28C', tooltip: true }, type: 'SEAT__JUMP_TO' };
                targetIframeWindow.postMessage(JSON.stringify(message), '*');
            }, 100);
        }, false);
    }
    ThemeEditorFile.init = init;
    function templateInputColorPicker(id, name, type, value) {
        if (value === void 0) { value = '#ffffff'; }
        return "\n<div class=\"form-group col-12 col-form-label\">\n    <div class=\"input-group input-group-sm colorpicker-component\">\n        <label class=\"label label-small small col-5\" for=\"" + id + "\">" + name + "</label>\n        <input\n            class=\"form-control colorpicker-input col-6\"\n            data-type=\"" + type + "\"\n            id=\"" + id + "\"\n            type=\"text\"\n            value=\"" + value + "\"\n        />\n        <span class=\"input-group-addon col-auto\"><i></i></span>\n    </div>\n</div>\n";
    }
    ThemeEditorFile.templateInputColorPicker = templateInputColorPicker;
    function templateFormGroup(header, content) {
        var id = str_1.Str.hash(header);
        return "\n<div class=\"card\">\n  <div\n    class=\"card-header\"\n    id=\"heading_" + id + "\"\n    role=\"tab\"\n  >\n    <span class=\"mb-0\">\n        <a\n          aria-controls=\"collapse_" + id + "\"\n          aria-expanded=\"false\"\n          class=\"\"\n          data-toggle=\"collapse\"\n          href=\"#collapse_" + id + "\"\n        >\n            " + header + "\n        </a>\n    </span>\n</div>\n    <div\n        aria-labelledby=\"heading_" + id + "\"\n        class=\"collapse\"\n        data-parent=\"#colors\"\n        id=\"collapse_" + id + "\"\n        role=\"tabpanel\"\n      >\n      <div class=\"card-body\">" + content + "</div>\n    </div>\n</div>\n";
    }
    ThemeEditorFile.templateFormGroup = templateFormGroup;
    init();
})(ThemeEditorFile = exports.ThemeEditorFile || (exports.ThemeEditorFile = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/client/themesEditor/index.ts
// module id = 134
// module chunks = 1